// extracted by mini-css-extract-plugin
module.exports = {"product_detail":"ProductFormDeatil_product_detail__pl6zU"};